export default "__VITE_ASSET__A04RNa0O__"